import { useSelector, useDispatch } from "react-redux";
import {
  useCreateInsuranceMutation,
  useUpdateInsuranceMutation,
} from "app/store/insurance/api/insuranceApi";
import {
  setShowInsuranceModal,
  setIsProcessing,
} from "app/store/insurance/slice/insuranceSlice";
import { showSuccessToast, showErrorToast } from "utils/toast";

const useInsuranceForm = () => {
  const { isUpdateOperation, isProcessing, selectedInsurance } = useSelector(
    (state) => state.insurance
  );
  const [createInsurance] = useCreateInsuranceMutation();
  const [updateInsurance] = useUpdateInsuranceMutation();
  const dispatch = useDispatch();

  const initialInsuranceValues = {
    payorId: selectedInsurance?.payor_id || "",
    payorName: selectedInsurance?.payor_name || "",
    street: selectedInsurance?.street || "",
    city: selectedInsurance?.city || "",
    state: selectedInsurance?.state || "",
    zip: selectedInsurance?.zip || "",
    phone: selectedInsurance?.phone || "",
  };

  const addInsurance = async (values) => {
    try {
      const payload = {
        payorId: values?.payorId?.replace(/\s+/g, " ").trim(),
        payorName: values?.payorName?.replace(/\s+/g, " ").trim(),
        street: values?.street?.replace(/\s+/g, " ").trim(),
        city: values?.city?.replace(/\s+/g, " ").trim(),
        state: values?.state?.replace(/\s+/g, " ").trim(),
        zip: values?.zip?.replace(/\s+/g, " ").trim(),
        phone: values?.phone?.replace(/\s+/g, " ").trim(),
      };

      dispatch(setIsProcessing(true));
      const { message } = await createInsurance(payload).unwrap();
      showSuccessToast(message);
      handleModalClose();
    } catch (error) {
      showErrorToast(error?.message || "An error occurred.");
    } finally {
      dispatch(setIsProcessing(false));
    }
  };

  const editInsurance = async (id, values) => {
    try {
      const payload = {
        payorId: values?.payorId?.replace(/\s+/g, " ").trim(),
        payorName: values?.payorName?.replace(/\s+/g, " ").trim(),
        street: values?.street?.replace(/\s+/g, " ").trim(),
        city: values?.city?.replace(/\s+/g, " ").trim(),
        state: values?.state?.replace(/\s+/g, " ").trim(),
        zip: values?.zip?.replace(/\s+/g, " ").trim(),
        phone: values?.phone?.replace(/\s+/g, " ").trim(),
      };

      dispatch(setIsProcessing(true));
      const { message } = await updateInsurance({ id, payload }).unwrap();
      showSuccessToast(message);
      handleModalClose();
    } catch (error) {
      showErrorToast(error?.message || "An error occurred.");
    } finally {
      dispatch(setIsProcessing(false));
    }
  };

  const handleFormSubmit = (values) => {
    isUpdateOperation && selectedInsurance
      ? editInsurance(selectedInsurance?._id, values)
      : addInsurance(values);
  };

  const handleModalClose = () => {
    dispatch(setShowInsuranceModal(false));
  };

  return {
    initialInsuranceValues,
    isProcessing,
    handleFormSubmit,
    handleModalClose,
  };
};

export default useInsuranceForm;
